import axios, { InternalAxiosRequestConfig } from "axios";
import { CognitoProvider } from "../features/authentication/contexts/CognitoProvider";

const jwtAxios = axios.create({
  // Prioritise using Dev's Base URL, if not present, will use relative host url.
  baseURL: process.env.REACT_APP_API_BASE_URL ?? "",
  withCredentials: true,
});

jwtAxios.interceptors.request.use(
  async (config: InternalAxiosRequestConfig<any>) => {
    if (config.headers['Content-Type'] !== 'multipart/form-data') {
      config.headers['Content-Type'] = 'application/json';
    }

    const token = await CognitoProvider.getAccessToken();
    if (token) {
      if (config.headers && token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
    }
    return config;
  },
  error => {
    Promise.reject(error);
  });

jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    // Check for failed token retrieval, and boot out.
    if (err.response && err.response.data.msg === "Token is not valid") {
      CognitoProvider.signout(() => { });
    }
    else if (err.response.status === 401) {
      return window.location.href = '/unauthorized';
    }
    return Promise.reject(err);
  }
);

export default jwtAxios;
